import { Link } from "react-router-dom";
import { ArrowUpRight, CalendarDays, ImageOff } from "lucide-react";
import { photoSrc, fmtPublished, eventShort } from "./newsUtils";

export const CategoryChip = ({ name, light = false }) => (
  <span className={`font-display text-[11px] font-bold uppercase tracking-[0.18em] ${light ? "text-gold" : "text-gold-deep"}`}>{name}</span>
);

export const UpcomingBadge = ({ testId }) => (
  <span className="inline-flex items-center gap-1.5 bg-gold px-2.5 py-1 font-display text-[11px] font-bold uppercase tracking-[0.16em] text-navy" data-testid={testId}>
    <CalendarDays size={13} aria-hidden="true" /> Upcoming Event
  </span>
);

export const NewsCard = ({ a, testPrefix = "news-card" }) => {
  const ev = a?.is_upcoming ? eventShort(a.event) : null;
  const img = photoSrc(a?.featured?.url_md);
  return (
    <Link to={`/news/${a.slug}`} className="group flex h-full flex-col border border-navy/10 bg-white transition-shadow duration-300 hover:shadow-[0_12px_36px_rgba(16,38,63,0.12)]" data-testid={`${testPrefix}-${a.slug}`}>
      <div className="relative aspect-[3/2] overflow-hidden bg-mist">
        {img ? (
          <img src={img} alt={a.featured?.alt || ""} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.04]" />
        ) : (
          <div className="flex h-full items-center justify-center text-slate"><ImageOff size={28} aria-hidden="true" /></div>
        )}
        {ev && (
          <span className="absolute left-4 top-4 flex flex-col items-center bg-navy px-3 py-2 text-paper" aria-hidden="true">
            <span className="font-display text-[11px] font-bold uppercase tracking-widest text-gold">{ev.month}</span>
            <span className="font-display text-2xl font-black leading-none">{ev.day}</span>
          </span>
        )}
      </div>
      <div className="flex flex-1 flex-col p-6">
        <div className="flex flex-wrap items-center gap-3">
          <CategoryChip name={a.category?.name} />
          {a.is_upcoming && <UpcomingBadge testId={`${testPrefix}-upcoming-${a.slug}`} />}
        </div>
        <h3 className="mt-3 text-lg font-extrabold leading-snug text-navy md:text-xl">{a.title}</h3>
        <p className="mt-3 line-clamp-3 text-sm leading-relaxed text-ink/80">{a.summary}</p>
        <div className="mt-auto flex items-center justify-between pt-6 text-xs text-slate">
          <time dateTime={a.publish_at}>{fmtPublished(a.publish_at)}</time>
          <span className="inline-flex items-center gap-1 font-semibold text-navy transition-colors group-hover:text-gold-deep">Read <ArrowUpRight size={14} aria-hidden="true" /></span>
        </div>
      </div>
    </Link>
  );
};
